import logo from '@/assets/logo.png'
import { STRINGS } from '@/constants'

interface Props {
  children: React.ReactNode
}

export default function PageShell({ children }: Props) {
  return (
    <div className="shell-root">
      <div className="shell-card">
        <div className="shell-header">
          <img src={logo} alt={STRINGS.app.name} className="h-6 w-auto" />
        </div>
        {children}
      </div>
    </div>
  )
}
